import { computed, ref } from 'vue'
import type { User } from '../../Types/user'

// User must a global state
const userRef = ref<User | null>(null)

export default function useUser(user: User | null = null) {
  if (null !== user) {
    userRef.value = user
  }

  const isPlatformClient = computed<boolean>(() => userRef.value?.isPlatformClient ?? false)
  const isReadOnly = computed<boolean>(() => userRef.value?.isReadOnly ?? false)

  function hasRole(role: string) {
    let roles
    if (Array.isArray(userRef.value?.roles)) {
      roles = userRef.value?.roles
    } else {
      roles = Object.values(userRef.value?.roles ?? {})
    }

    return roles.includes(role)
  }

  return {
    // Ref
    user: userRef,
    // Computed
    isPlatformClient,
    isReadOnly,
    // Methods
    hasRole,
  }
}
